import styled from 'styled-components';

import {colors, font} from 'theme';

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;

export const Buttons = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

export const Description = styled.div<{step: number}>`
    margin-bottom: 20px;
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    text-align: center;
    color: ${(p) => (p.step === 0 ? colors.textSecondary : colors.textPrimary)};
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80px;
`;
